import { userDestinationsActions, userDestinationsSelectors } from '@anm/store/modules/userDestinations';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useConnectDestinations = (onModalClose: () => void) => {
  const dispatch = useDispatch();
  const [isConnecting, setIsConnecting] = useState(false);

  const isListPending = useSelector(userDestinationsSelectors.selectDestinationsListIsPending);
  const canCheckErrors = useSelector(userDestinationsSelectors.selectCanCheckErrors);
  const isToggleDestinationPending = useSelector(userDestinationsSelectors.selectIsToggleDestinationPending);

  const isPending = isListPending || isToggleDestinationPending;

  const onConnect = (id: string) => {
    dispatch(userDestinationsActions.toggleSocialDestinations({ [id]: true }));
    setIsConnecting(true);
  };

  useEffect(() => {
    const canCloseModal = isConnecting && canCheckErrors;

    canCloseModal && onModalClose();
  }, [isConnecting, canCheckErrors]);

  return [onConnect, isPending] as const;
};

export default useConnectDestinations;
